export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export interface Category {
  id: string;
  nameKey: string;
  link: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'category_shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20pair%20of%20chunky%20white%20and%20terracotta%20sneakers%20floating%20on%20a%20warm%20terracotta%20orange%20background%20with%20subtle%20long%20shadow%20dramatic%20soft%20light%20bold%20minimal%20ecommerce%20hero%20product%20shot%20with%20crisp%20rubber%20sole%20texture&width=600&height=600&seq=cat-shoes-v2&orientation=squarish',
  },
  {
    id: 'hoodies',
    nameKey: 'category_hoodies',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20folded%20sage%20green%20hoodie%20sweater%20neatly%20stacked%20on%20a%20soft%20mint%20pastel%20background%20with%20gentle%20fabric%20folds%20and%20a%20tiny%20hanging%20tag%20soft%20diffused%20daylight%20fresh%20clean%20minimal%20ecommerce%20product%20photography&width=600&height=600&seq=cat-hoodies-v2&orientation=squarish',
  },
  {
    id: 'tshirts',
    nameKey: 'category_tshirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Three%20pastel%20tshirts%20in%20blush%20pink%20sky%20mint%20and%20butter%20yellow%20hanging%20on%20a%20thin%20wooden%20rail%20against%20a%20warm%20cream%20wall%20soft%20airy%20natural%20light%20crisp%20cotton%20texture%20fresh%20boutique%20product%20photography&width=600&height=600&seq=cat-tshirts-v2&orientation=squarish',
  },
  {
    id: 'jackets',
    nameKey: 'category_jackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20camel%20brown%20lightweight%20bomber%20jacket%20on%20a%20wooden%20hanger%20against%20a%20warm%20taupe%20textured%20wall%20with%20soft%20side%20lighting%20and%20gentle%20shadow%20rich%20fabric%20detail%20premium%20minimal%20ecommerce%20product%20shot&width=600&height=600&seq=cat-jackets-v2&orientation=squarish',
  },
  {
    id: 'pants',
    nameKey: 'category_pants',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20pair%20of%20beige%20cargo%20pants%20and%20dark%20olive%20shorts%20stacked%20with%20a%20leather%20belt%20coiled%20on%20top%20on%20a%20warm%20sand%20linen%20surface%20soft%20natural%20light%20clean%20minimal%20apparel%20product%20photography&width=600&height=600&seq=cat-pants-v2&orientation=squarish',
  },
  {
    id: 'headwear',
    nameKey: 'category_headwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20mustard%20yellow%20baseball%20cap%20and%20a%20cream%20knit%20beanie%20side%20by%20side%20on%20a%20soft%20buttercream%20yellow%20background%20with%20gentle%20shadows%20and%20a%20small%20leaf%20accent%20fresh%20playful%20minimal%20headwear%20product%20photography&width=600&height=600&seq=cat-headwear-v2&orientation=squarish',
  },
  {
    id: 'sets',
    nameKey: 'category_sets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20matching%20peach%20athletic%20track%20set%20with%20jacket%20and%20pants%20displayed%20flat%20on%20a%20soft%20apricot%20pastel%20background%20with%20neat%20folds%20and%20a%20small%20folded%20towel%20accent%20warm%20bright%20minimal%20sportswear%20product%20photography&width=600&height=600&seq=cat-sets-v2&orientation=squarish',
  },
  {
    id: 'underwear',
    nameKey: 'category_underwear',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20tidy%20stack%20of%20soft%20cotton%20underwear%20in%20ivory%20blush%20and%20dove%20gray%20tones%20with%20a%20sprig%20of%20eucalyptus%20on%20a%20clean%20linen%20background%20soft%20warm%20daylight%20gentle%20shadows%20fresh%20minimal%20intimate%20apparel%20product%20photography&width=600&height=600&seq=cat-underwear-v2&orientation=squarish',
  },
  {
    id: 'jersey',
    nameKey: 'category_jersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20vibrant%20red%20and%20white%20athletic%20jersey%20with%20subtle%20geometric%20pattern%20laid%20flat%20on%20a%20soft%20mint%20green%20background%20with%20a%20small%20soccer%20ball%20nearby%20bright%20energetic%20clean%20minimal%20sportswear%20product%20photography&width=600&height=600&seq=cat-jersey-v2&orientation=squarish',
  },
  {
    id: 'accessories',
    nameKey: 'category_accessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20curated%20flat%20lay%20of%20a%20gold%20watch%20round%20sunglasses%20and%20a%20leather%20bracelet%20arranged%20in%20a%20circle%20on%20a%20warm%20honey%20yellow%20background%20soft%20golden%20light%20crisp%20reflections%20minimal%20luxury%20accessories%20product%20photography&width=600&height=600&seq=cat-accessories-v2&orientation=squarish',
  },
  {
    id: 'bags',
    nameKey: 'category_bags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20caramel%20leather%20tote%20bag%20and%20a%20canvas%20backpack%20leaning%20against%20each%20other%20on%20a%20soft%20terracotta%20background%20with%20warm%20side%20lighting%20and%20gentle%20shadow%20rich%20material%20texture%20minimal%20bags%20product%20photography&width=600&height=600&seq=cat-bags-v2&orientation=squarish',
  },
  {
    id: 'belts',
    nameKey: 'category_belts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Three%20rolled%20leather%20belts%20in%20tan%20brown%20and%20black%20arranged%20in%20a%20neat%20row%20on%20a%20warm%20camel%20beige%20background%20with%20brass%20buckle%20detail%20and%20soft%20shadows%20premium%20minimal%20belt%20product%20photography&width=600&height=600&seq=cat-belts-v2&orientation=squarish',
  },
  {
    id: 'perfumes',
    nameKey: 'category_perfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20with%20a%20soft%20pink%20rose%20beside%20it%20on%20a%20blush%20pink%20background%20with%20delicate%20soft%20light%20and%20subtle%20reflections%20fresh%20feminine%20minimal%20fragrance%20product%20photography&width=600&height=600&seq=cat-perfumes-v2&orientation=squarish',
  },
  {
    id: 'other',
    nameKey: 'category_other',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20neat%20assortment%20of%20small%20lifestyle%20goods%20a%20water%20bottle%20sunglasses%20keychain%20and%20notebook%20arranged%20on%20a%20soft%20stone%20gray%20background%20with%20gentle%20shadows%20warm%20neutral%20minimal%20lifestyle%20product%20photography&width=600&height=600&seq=cat-other-v2&orientation=squarish',
  },
];